const API = process.env.REACT_APP_API_URL || '';
const TOKEN_STORAGE_KEY = 'workflow_builder_auth_token_v1';
export const AUTH_UNAUTHORIZED_EVENT = 'workflow_builder_auth_unauthorized';

export function apiUrl(path: string): string {
  return `${API}${path}`;
}

export function getAuthToken(): string {
  try {
    return localStorage.getItem(TOKEN_STORAGE_KEY) || '';
  } catch {
    return '';
  }
}

export function setAuthToken(token: string): void {
  try {
    localStorage.setItem(TOKEN_STORAGE_KEY, token);
  } catch {
    // ignore storage failures
  }
}

export function clearAuthToken(): void {
  try {
    localStorage.removeItem(TOKEN_STORAGE_KEY);
  } catch {
    // ignore storage failures
  }
}

function withAuthHeaders(init?: RequestInit): Headers {
  const headers = new Headers(init?.headers || {});
  const token = getAuthToken();
  if (token) {
    headers.set('Authorization', `Bearer ${token}`);
  }
  return headers;
}

export async function authFetch(path: string, init?: RequestInit): Promise<Response> {
  const res = await fetch(apiUrl(path), {
    ...(init || {}),
    headers: withAuthHeaders(init),
  });
  if (res.status === 401) {
    window.dispatchEvent(new Event(AUTH_UNAUTHORIZED_EVENT));
  }
  return res;
}

export function buildWsUrl(path: string): string {
  const wsProtocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  const wsHost = API ? new URL(API, window.location.origin).host : window.location.host;
  const token = getAuthToken();
  const params = new URLSearchParams();
  if (token) params.set('token', token);
  const qs = params.toString();
  return `${wsProtocol}//${wsHost}${path}${qs ? `?${qs}` : ''}`;
}
